import React from 'react';
import { Trophy, Coins, User, Menu } from 'lucide-react';
import Link from './Link';

function Header() {
  return (
    <header className="fixed top-0 w-full backdrop-blur-md bg-white/50 z-50">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16 items-center">
          <div className="flex items-center">
            <Trophy className="h-8 w-8 text-[#0dceda]" />
            <span className="ml-2 text-xl font-bold bg-gradient-to-r from-white to-[#0dceda] text-transparent bg-clip-text">
              Challenge Hub
            </span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <Link href="/challenges">Challenges</Link>
            <Link href="/rewards">Rewards</Link>
            <Link href="/profile">Profile</Link>
          </div>

          <div className="flex items-center space-x-4">
            <div className="hidden md:flex items-center bg-white/90 rounded-full px-4 py-2 shadow-lg">
              <Coins className="h-5 w-5 text-[#0dceda]" />
              <span className="ml-2 font-semibold">1,250 Credits</span>
            </div>
            <button className="p-2 rounded-full hover:bg-white/20 transition-colors">
              <User className="h-6 w-6 text-[#0dceda]" />
            </button>
            <button className="md:hidden p-2 rounded-full hover:bg-white/20 transition-colors">
              <Menu className="h-6 w-6 text-[#0dceda]" />
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;